import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuilderTopic = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Activity_Icon",
	"data-name": "Activity Icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		id: "Rectangle_934",
		"data-name": "Rectangle 934",
		width: 16,
		height: 16,
		fill: "rgba(255,255,255,0)"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Union_8",
		"data-name": "Union 8",
		d: "M.025,10.25V6.717s-.056-2.229,0-2.853a5.094,5.094,0,0,1,5.256,1.68c1.086-.852,2.513-2.3,5.292-1.68-.009,3.18,0,2.773,0,2.773V10.25a11.674,11.674,0,0,0-5.292,1.136C3.425,10.079.025,10.25.025,10.25Zm3.188-.643a6.953,6.953,0,0,1,2.069.953,7.745,7.745,0,0,1,2.152-.953,7.667,7.667,0,0,1,2.344-.131V4.54a8.389,8.389,0,0,0-2.344.625,10.15,10.15,0,0,0-2.152,1.4,9.077,9.077,0,0,0-2.069-1.4A8.2,8.2,0,0,0,.87,4.54V9.476a7.749,7.749,0,0,1,.787-.037A6.673,6.673,0,0,1,3.213,9.607Zm.419-6.736c-.39-.42.866-1.087,1.655-1.087s1.975.57,1.621,1-.83-.226-1.621-.226C4.674,2.562,4.249,3,3.909,3A.365.365,0,0,1,3.632,2.871ZM5.312.956c-1.319,0-2.135,1.085-2.786.57S3.993,0,5.312,0,8.52.993,7.93,1.525a.521.521,0,0,1-.362.146C7.041,1.671,6.376.956,5.312.956Z",
		transform: "translate(3 1.999)"
	})]
});
export default SvgBuilderTopic;
